export const environment = {
    production: false,
    // baseUrl: 'https://analytics.traversia.net/api'
    baseUrl: 'https://analytics-dev.traversia.net/api'
    // baseUrl: 'http://localhost:3000/api'
  };
  